module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/main-visual_beach-photo-696aa5f4b0f3aa3069f041f1c58dd38b.webp";